import './src/vaadin-checkbox.js';
export * from './src/vaadin-checkbox.js';
